import React from 'react'
import {KTSVG} from '../../../_metronic/helpers'

type Props = {
  className?: string
  title: string
  handleAddModal?: () => void
}

function AddButton({className, title, handleAddModal}: Props) {
  return (
    <button
      className={`btn btn-light-primary btn-sm px-3 py-1 mx-3 text-uppercase ${className}`}
      onClick={handleAddModal}
    >
      <KTSVG
        path='/media/icons/duotune/general/gen035.svg'
        className='svg-icon-3 svg-icon-success mr-2 '
      />
      {title}
    </button>
  )
}

export default AddButton
